import { render, staticRenderFns } from "./FeatureTittle.vue?vue&type=template&id=4265335a"
import script from "./FeatureTittle.vue?vue&type=script&lang=js"
export * from "./FeatureTittle.vue?vue&type=script&lang=js"
import style0 from "./FeatureTittle.vue?vue&type=style&index=0&id=4265335a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports